import dynamic from 'next/dynamic'

import {
  Button,
  Container,
  Icon,
  Modal,
  PlanList,
  SectionHeader
} from '@/components'

import { usePlansSection } from './usePlansSection'

import styles from './Plans.module.scss'

const Calculator = dynamic(() =>
  import('@/components/Calculator/Calculator').then((mod) => mod.Calculator)
)

export const Plans = () => {
  const {
    control,
    isLoading,
    isMobile,
    isSimulationVisible,
    setIsSimulationVisible,
    onSelectPlan,
    onSubmit,
    handleSubmit
  } = usePlansSection()

  return (
    <section id="planos" className={styles.plans}>
      <Container>
        <SectionHeader
          tagText="Planos Pós-pago"
          title={
            <>
              Escolha o melhor <b>plano para o seu négócio</b>
            </>
          }
          subtitle="Todos os planos incluem os relatórios para Pessoa Física e Jurídica, sem fidelidade."
        />

        <form onSubmit={handleSubmit(onSubmit)}>
          <PlanList
            control={control}
            onSelectPlan={onSelectPlan}
            onClickCTA={onSelectPlan}
          />

          <Button
            type="submit"
            id="plans-wantToHire-button"
            isLoading={isLoading}
            className={`
              ${styles.plans__button} 
              ${styles['plans__button--fixed']}
            `}
          >
            Quero contratar
          </Button>

          {isMobile && (
            <Button
              variant="secondary"
              id="plans-custom-button"
              className={styles.plans__button}
              onClick={() => setIsSimulationVisible(true)}
            >
              Quero descobrir meu plano ideal
              <Icon name="equifax-arrow-right-circle" size="small" />
            </Button>
          )}
        </form>

        <p className={styles.plans__disclaimer}>
          A quantidade de consultas pode variar de acordo com o relatório
          utilizado. <br />A assinatura de qualquer plano possui renovação
          automática.
        </p>
      </Container>

      {isSimulationVisible && (
        <Modal
          size="medium"
          section="simulation"
          customClass={styles.plans__simulationModal}
          onClose={() => setIsSimulationVisible(false)}
        >
          <Calculator />
        </Modal>
      )}
    </section>
  )
}
